angular.module('userSettingsMod')

.controller('groupSharing', ['$location', '$scope', 'GhDialog', 'localizationService', async function($location, $scope, GhDialog, localizationService) {
  const dictionary = localizationService.getDictionary('account_settings');
  $scope.translate = (word) => localizationService.translate(word, dictionary);

  $scope.showDialog = function() {
		GhDialog.show({
			position: 'center',
			toolbar: false,
			locals: {
				groups: $scope.userGroups
			},
			template: {
				toolbar: '',
        resizable: false,
				content: `
				<div class="dialog-share-group">
					<span gh-icon="group 0D99FF 65px"></span>
					<p class="dialog-share-group__title">{{translate('Add group')}}</p>
				</div>
				<div class="dialog-share-group__content">
					<div class="dialog-share-group__content__input">
					<label for="group_name">{{translate('Group name')}}</label>
						<input id="group_name" ng-model="groupName" type="text" placeholder="Type group name here...">
						<div ng-show="errMessage" class="error_message">{{errMessage}}</div>
					</div>
					<div class="dialog-share-group__content__buttons">
						<button class="dialog-share-group__content__buttons__cancel btn btn-blue-reverse" ng-click="cancel()">Cancel</button>
						<button class="dialog-share-group__content__buttons__add btn btn-blue" ng-click="addGroup(groupName)">Add</button>
					</div>
				</div>`,
			},
				controller: ['$scope','groups', 'localizationService', function ($scope, groups, localizationService) {
					const dictionary = localizationService.getDictionary('account_settings');
					$scope.translate = (word) => localizationService.translate(word, dictionary);
					$scope.errMessage = '';

          $scope.addGroup = async (groupName) => {
						if(!groupName) {
							$scope.errMessage = 'Please, type group name';
							return;
						}
						try {
							let group = await gudhub.groupSharing.createGroup(groupName);
							group.group_permission = '3'; //if user create group, he is owner
							groups.push(group);
							$scope.$apply();
							if(group) {
								$scope.cancel();
							}
						} catch(error) {
							$scope.errMessage = 'Something went wrong. Please, try again';
						}
					}

        }]

		})
	}

	$scope.userGroups = await gudhub.groupSharing.getGroupsByUser(gudhub.storage.getUser().user_id);
	$scope.$apply();

	$scope.cancel = function(){
		$location.path('/apps');
	};

}]);
